import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Textarea } from '../../components/ui/textarea.jsx';
import { examService } from '../../services/examService';

const ExamCreate = () => {
  const [form, setForm] = React.useState({ title: '', description: '', classId: '', subjectId: '', examDate: '', startTime: '', duration: 60 });
  const [saving, setSaving] = React.useState(false);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const save = async () => {
    try {
      setSaving(true);
      await examService.createExam(form);
      window.history.back();
    } catch (e) {
      alert(e.response?.data?.message || 'Failed to create exam');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-4">
      <Card>
        <CardHeader>
          <CardTitle>Create Exam</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <Input placeholder="Title" value={form.title} onChange={update('title')} />
          <Textarea placeholder="Description" value={form.description} onChange={update('description')} />
          <Input placeholder="Class ID" value={form.classId} onChange={update('classId')} />
          <Input placeholder="Subject ID" value={form.subjectId} onChange={update('subjectId')} />
          <Input placeholder="Exam Date (YYYY-MM-DD)" value={form.examDate} onChange={update('examDate')} />
          <Input placeholder="Start Time (HH:mm)" value={form.startTime} onChange={update('startTime')} />
          <Input placeholder="Duration (mins)" value={form.duration} onChange={update('duration')} />
          <Button onClick={save} disabled={saving}>{saving ? 'Saving...' : 'Create'}</Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default ExamCreate;


